import React from 'react';
import './MainTestPage.css';

function MainTestPage() {
  return (
    <div className="main-test-page">
      <header className="main-test-header">
        <div className="main-test-logo">
          <div className="main-test-logo-mark" aria-hidden="true" />
          <div className="main-test-logo-text">
            <span className="main-test-logo-title">wonderland</span>
            <span className="main-test-logo-sub">원더랜드</span>
          </div>
        </div>
        <nav className="main-test-nav">
          <button className="main-test-link">회사소개</button>
          <button className="main-test-link">개설신청</button>
          <button className="main-test-link">LOG IN</button>
          <button className="main-test-cta">입학상담 LEVEL TEST</button>
        </nav>
      </header>

      <section className="main-test-hero">
        <div className="main-test-hero-left">
          <div className="main-test-hero-planet">
            <div className="main-test-hero-sky" aria-hidden="true" />
            <div className="main-test-hero-hill" aria-hidden="true" />
            <div className="main-test-hero-characters" aria-hidden="true">
              <div className="main-test-character main-test-character-girl" />
              <div className="main-test-character main-test-character-boy" />
            </div>
          </div>
          <div className="main-test-hero-copy">
            <h1>Everyone Smile In Wonderland</h1>
            <p>
              아이들의 꿈과 상상이 자라는 공간. 창의적인 학습과 놀이가 어우러진
              원더랜드의 새로운 메인페이지 테스트입니다.
            </p>
            <div className="main-test-hero-buttons">
              <button className="main-test-primary">ALT Program</button>
              <button className="main-test-secondary">Program 안내</button>
            </div>
          </div>
        </div>

        <aside className="main-test-hero-right">
          <div className="main-test-tabs">
            <button className="main-test-tab active">NOTICE</button>
            <button className="main-test-tab">NEWS</button>
          </div>
          <ul className="main-test-notice-list">
            <li>전국 원더랜드 학원장 협의</li>
            <li>원더랜드 2024 학원장 워크숍</li>
            <li>교육 프로그램 Wonderland Assessment</li>
            <li>원더랜드 오전/오후 프로그램 Wonder Kids</li>
            <li>Wonderland Kinder Placement Test 개발</li>
          </ul>
          <div className="main-test-more">MORE</div>
          <div className="main-test-callout">
            <div className="main-test-callout-title">원더랜드 학원 대표문의</div>
            <div className="main-test-callout-phone">051.626.3195</div>
            <div className="main-test-callout-desc">
              지금 바로 문의하세요.
            </div>
          </div>
        </aside>
      </section>

      <section className="main-test-features">
        <div className="main-test-feature-card">
          <div className="main-test-feature-icon program" />
          <div className="main-test-feature-title">Program</div>
          <p>원더랜드의 핵심 커리큘럼을 소개합니다.</p>
        </div>
        <div className="main-test-feature-card">
          <div className="main-test-feature-icon event" />
          <div className="main-test-feature-title">Event</div>
          <p>다양한 체험형 교육 이벤트를 운영합니다.</p>
        </div>
        <div className="main-test-feature-card">
          <div className="main-test-feature-icon campus" />
          <div className="main-test-feature-title">수도권 본사</div>
          <p>전국 네트워크와 본사 지원을 제공합니다.</p>
        </div>
      </section>

      <section className="main-test-bottom">
        <div className="main-test-bottom-card home">
          <div className="main-test-bottom-title">원더랜드 HOMEWORK</div>
          <p>읽고 따라하며 배우는 즐거운 학습</p>
        </div>
        <div className="main-test-bottom-card data">
          <div className="main-test-bottom-title">원더랜드 DATA ROOM</div>
          <p>다양한 교육자료를 제공합니다</p>
        </div>
        <div className="main-test-bottom-card connect">
          <div className="main-test-bottom-title">원더랜드 네트워크</div>
          <p>학원 운영을 위한 다양한 시스템 제공</p>
        </div>
      </section>
    </div>
  );
}

export default MainTestPage;
